var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStandard = function SvgStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410 164"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E62B1E",
    d: "M42.962 54h-41V16h127v38h-41v109h-45zm93-38h124v38h-78v18h78v35h-78v18h78v38h-124zm176 109 18.594.126c28.16 0 32.276-22.814 32.276-36.595 0-9.233-3.189-34.531-35.87-34.531h-15zm-45-109h74.898c48.9 0 66.178 36.172 66.178 73.15 0 45.022-23.832 73.85-75.008 73.85h-66.068z"
  })));
};
export default SvgStandard;